import Outdoor_01 from 'assets/images/pictures/outdoor/outdoor_01.JPG';
import Outdoor_02 from 'assets/images/pictures/outdoor/outdoor_02.JPG';
import Outdoor_03 from 'assets/images/pictures/outdoor/outdoor_03.JPG';
import Outdoor_04 from 'assets/images/pictures/outdoor/outdoor_04.JPG';
import Outdoor_05 from 'assets/images/pictures/outdoor/outdoor_05.JPG';
import Outdoor_06 from 'assets/images/pictures/outdoor/outdoor_06.JPG';
import Outdoor_07 from 'assets/images/pictures/outdoor/outdoor_07.JPG';
import Outdoor_08 from 'assets/images/pictures/outdoor/outdoor_08.JPG';
import Outdoor_09 from 'assets/images/pictures/outdoor/outdoor_09.JPG';
import Outdoor_10 from 'assets/images/pictures/outdoor/outdoor_10.JPG';
import Outdoor_11 from 'assets/images/pictures/outdoor/outdoor_11.JPG';
import Outdoor_12 from 'assets/images/pictures/outdoor/outdoor_12.JPG';
import Outdoor_13 from 'assets/images/pictures/outdoor/outdoor_13.JPG';
import Outdoor_14 from 'assets/images/pictures/outdoor/outdoor_14.JPG';
import Outdoor_15 from 'assets/images/pictures/outdoor/outdoor_15.JPG';
import Outdoor_16 from 'assets/images/pictures/outdoor/outdoor_16.jpg';
import Outdoor_17 from 'assets/images/pictures/outdoor/outdoor_17.jpg';
import Outdoor_18 from 'assets/images/pictures/outdoor/outdoor_18.jpg';
import Outdoor_19 from 'assets/images/pictures/outdoor/outdoor_19.jpg';
import Outdoor_20 from 'assets/images/pictures/outdoor/outdoor_20.jpg';
import Outdoor_21 from 'assets/images/pictures/outdoor/outdoor_21.jpg';
import Outdoor_22 from 'assets/images/pictures/outdoor/outdoor_22.jpg';
import Outdoor_23 from 'assets/images/pictures/outdoor/outdoor_23.jpg';
import Outdoor_24 from 'assets/images/pictures/outdoor/outdoor_24.jpg';
import Outdoor_25 from 'assets/images/pictures/outdoor/outdoor_25.jpg';
import YoutubeEmbed from 'assets/videos/YoutubeEmbed';

const OutdoorSlides = [
  //   {
  //     id: 0,
  //     component: (
  //       <YoutubeEmbed
  //         embedId='JgM_l3yPdK4?si=CqtxlzgdyFdM9EIG'
  //         title='活力秘技'
  //       />
  //     ),
  //   },
  {
    id: 1,
    component: (
      <img
        src={Outdoor_01}
        style={{ maxWidth: '100%', height: 'auto' }}
        alt='Outdoor 01'
      />
    ),
  },
  {
    id: 2,
    component: (
      <img
        src={Outdoor_02}
        style={{ maxWidth: '100%', height: 'auto' }}
        alt='Outdoor 02'
      />
    ),
  },
  {
    id: 3,
    component: (
      <img
        src={Outdoor_03}
        style={{ maxWidth: '100%', height: 'auto' }}
        alt='Outdoor 03'
      />
    ),
  },
  {
    id: 4,
    component: (
      <img
        src={Outdoor_04}
        style={{ maxWidth: '100%', height: 'auto' }}
        alt='Outdoor 04'
      />
    ),
  },
  {
    id: 5,
    component: (
      <img
        src={Outdoor_05}
        style={{ maxWidth: '100%', height: 'auto' }}
        alt='Outdoor 05'
      />
    ),
  },
  {
    id: 6,
    component: (
      <img
        src={Outdoor_06}
        style={{ maxWidth: '100%', height: 'auto' }}
        alt='Outdoor 06'
      />
    ),
  },
  {
    id: 7,
    component: (
      <img
        src={Outdoor_07}
        style={{ maxWidth: '100%', height: 'auto' }}
        alt='Outdoor 07'
      />
    ),
  },
  {
    id: 8,
    component: (
      <img
        src={Outdoor_08}
        style={{ maxWidth: '100%', height: 'auto' }}
        alt='Outdoor 08'
      />
    ),
  },
  {
    id: 9,
    component: (
      <img
        src={Outdoor_09}
        style={{ maxWidth: '100%', height: 'auto' }}
        alt='Outdoor 09'
      />
    ),
  },
  {
    id: 10,
    component: (
      <img
        src={Outdoor_10}
        style={{ maxWidth: '100%', height: 'auto' }}
        alt='Outdoor 10'
      />
    ),
  },
  {
    id: 11,
    component: (
      <img
        src={Outdoor_11}
        style={{ maxWidth: '100%', height: 'auto' }}
        alt='Outdoor 11'
      />
    ),
  },
  {
    id: 12,
    component: (
      <img
        src={Outdoor_12}
        style={{ maxWidth: '100%', height: 'auto' }}
        alt='Outdoor 12'
      />
    ),
  },
  {
    id: 13,
    component: (
      <img
        src={Outdoor_13}
        style={{ maxWidth: '100%', height: 'auto' }}
        alt='Outdoor 13'
      />
    ),
  },
  {
    id: 14,
    component: (
      <img
        src={Outdoor_14}
        style={{ maxWidth: '100%', height: 'auto' }}
        alt='Outdoor 14'
      />
    ),
  },
  {
    id: 15,
    component: (
      <img
        src={Outdoor_15}
        style={{ maxWidth: '100%', height: 'auto' }}
        alt='Outdoor 15'
      />
    ),
  },
  {
    id: 16,
    component: (
      <img
        src={Outdoor_16}
        style={{ maxWidth: '100%', height: 'auto' }}
        alt='Outdoor 16'
      />
    ),
  },
  {
    id: 17,
    component: (
      <img
        src={Outdoor_17}
        style={{ maxWidth: '100%', height: 'auto' }}
        alt='Outdoor 17'
      />
    ),
  },
  {
    id: 18,
    component: (
      <img
        src={Outdoor_18}
        style={{ maxWidth: '100%', height: 'auto' }}
        alt='Outdoor 18'
      />
    ),
  },
  {
    id: 19,
    component: (
      <img
        src={Outdoor_19}
        style={{ maxWidth: '100%', height: 'auto' }}
        alt='Outdoor 19'
      />
    ),
  },
  {
    id: 20,
    component: (
      <img
        src={Outdoor_20}
        style={{ maxWidth: '100%', height: 'auto' }}
        alt='Outdoor 20'
      />
    ),
  },
  {
    id: 21,
    component: (
      <img
        src={Outdoor_21}
        style={{ maxWidth: '100%', height: 'auto' }}
        alt='Outdoor 21'
      />
    ),
  },
  {
    id: 22,
    component: (
      <img
        src={Outdoor_22}
        style={{ maxWidth: '100%', height: 'auto' }}
        alt='Outdoor 22'
      />
    ),
  },
  {
    id: 23,
    component: (
      <img
        src={Outdoor_23}
        style={{ maxWidth: '100%', height: 'auto' }}
        alt='Outdoor 23'
      />
    ),
  },
  {
    id: 24,
    component: (
      <img
        src={Outdoor_24}
        style={{ maxWidth: '100%', height: 'auto' }}
        alt='Outdoor 24'
      />
    ),
  },
  {
    id: 25,
    component: (
      <img
        src={Outdoor_25}
        style={{ maxWidth: '100%', height: 'auto' }}
        alt='Outdoor 25'
      />
    ),
  },
];

export default OutdoorSlides;
